export const getBadge = (
  promotionName: string | undefined,
  campaign: string[],
  bundleLabel: string | null,
  label: string[]
) => {
  return promotionName || campaign.join(' ') || bundleLabel || label?.join(' ') || ''
}
